import { DataProvider } from 'react-admin'

const provider = {} as DataProvider

export default provider
